import { FC } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";

interface TableSkeletonLoaderProps {
  columns: number;
  rows?: number;
  tableHeight?: number | string;
}

const TableSkeletonLoader: FC<TableSkeletonLoaderProps> = ({
  columns,
  rows = 10,
  tableHeight = "64vh",
}) => {
  const columnCount = Math.max(columns, 1);

  return (
    <TableContainer
      sx={{
        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.07)",
        borderRadius: 2,
        maxHeight: tableHeight,
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {Array.from({ length: columnCount }, (_, index) => (
              <TableCell key={index}>
                <Skeleton variant="text" sx={{ fontSize: "0.9rem" }} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }, (_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: columnCount }, (_, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton variant="text" sx={{ fontSize: "0.85rem" }} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSkeletonLoader;
